import Cookies from 'js-cookie'
const mutations = {
  //登录
  LOGIN: (state, data) => {
    state.userId = data.id;
    state.user = data.name;
    state.token = data.token;
    state.autoLogin = data.autoLogin;
    state.userImage = data.photo;
    state.expirationTime = data.expirationTime;
    state.islogined = true;

    //使用cookies 控制使用url访问新建页签用户登录信息共享
    let expiresTime = state.expirationTime;
    if (expiresTime && state.autoLogin) {
      //登录勾选记住密码且有过期时间
      let expiresTime_ = {
        expires: new Date(Number(expiresTime))
      };
      Cookies.set('userId', state.userId, expiresTime_);
      Cookies.set('user', state.user, expiresTime_);
      Cookies.set('token', state.token, expiresTime_);
      Cookies.set('autoLogin', state.autoLogin, expiresTime_);
      Cookies.set('userImage', state.userImage, expiresTime_);
      Cookies.set('expirationTime', state.expirationTime, expiresTime_);
      Cookies.set('islogined', state.islogined, expiresTime_);
    } else {
      //不设置有效时间,关闭历览器清除
      Cookies.set('userId', state.userId);
      Cookies.set('user', state.user);
      Cookies.set('token', state.token);
      Cookies.set('autoLogin', state.autoLogin);
      Cookies.set('userImage', state.userImage);
      Cookies.set('expirationTime', state.expirationTime);
      Cookies.set('islogined', state.islogined);
    }
  },
  //登出
  LOGOUT: (state, value) => {
    //登出清除状态数据
    state.user = null;
    state.token = null;
    state.userId = '';
    state.userImage = '';
    state.expirationTime = 0;
    state.autoLogin = false;
    state.islogined = false;

    //清除cookies 数据
    Cookies.remove('userId');
    Cookies.remove('user');
    Cookies.remove('token');
    Cookies.remove('autoLogin');
    Cookies.remove('userImage');
    Cookies.remove('expirationTime');
    Cookies.remove('islogined');

  },
  //登录状态校验
  CHEACK_LOGIN: (state) => {
    var token = state.token;
    // console.log(`-------------- ${token}`);
    var autoLogin = state.autoLogin;
    var expirationTime = state.expirationTime;
    var islogined = state.islogined;
    var loginValid = true; //登录有效
    //判断会话是否登录
    if (token === null || token === 'null' || token === '') {
      loginValid = false; //登录失效
    }
    //是否需要自动登录
    if (expirationTime === null || expirationTime === 'null' || expirationTime === ''  || expirationTime === undefined) {
      loginValid = false; //登录失效
    } else {
      var time_ = new Date().getTime(); //当前时间戳
      var expirationTime_ = Number(expirationTime); //失效时间戳
      if ((time_ - expirationTime_) >= 0) {
        //当前时间超过失效时间   token失效
        loginValid = false; //登录失效
      } else {
        loginValid = true; //登录有效
      }
    }

    if (loginValid) {
      state.islogined = true;
    } else {
      state.islogined = false;
    }
  },
  //更新显示昵称
  updateUser: (state, value) => {
    state.userInfoChange = true; //用户信息更新标识
    if (value.user) { //更新昵称
      state.user = value.user;
      localStorage.setItem('user', state.user);
      //使用cookies 控制使用url访问新建页签用户登录信息共享
      let expiresTime = state.expirationTime;
      if (expiresTime && state.autoLogin) {
        //登录勾选记住密码且有过期时间
        let expiresTime_ = {
          expires: new Date(Number(expiresTime))
        };
        Cookies.set('user', state.user, expiresTime_);
      } else {
        //不设置有效时间,关闭历览器清除
        Cookies.set('user', state.user);
      }
    }
    if (value.userImage) { //更新头像
      state.userImage = value.userImage;
      localStorage.setItem('userImage', state.userImage);

      //使用cookies 控制使用url访问新建页签用户登录信息共享
      let expiresTime = state.expirationTime;
      if (expiresTime && state.autoLogin) {
        //登录勾选记住密码且有过期时间
        let expiresTime_ = {
          expires: new Date(Number(expiresTime))
        };
        Cookies.set('userImage', state.userImage, expiresTime_);
      } else {
        //不设置有效时间,关闭历览器清除
        Cookies.set('userImage', state.userImage);
      }
    }
  }
}
export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js